export default __webpack_public_path__ + "static/media/i201jk.15afb975.webp";